<script>
    let className = '';
    export { className as class };  
    export let xs = false;
    export let sm = false;
    export let lg = false;
    export let xl = false;
    export let invert = false;
    export let fluid = false;

    /** @type {'div' | 'article' | 'section'} */
    export let tag = 'div';
</script>

<svelte:element
    this={tag}
    class="prose prose-headings:mb-[.3em] prose-headings:first:mt-0 {className}
        {invert ? 'prose-invert' : ''}
        {
        xs
        ? 'max-sm:prose-sm'
        : sm
        ? 'max-sm:prose-sm md:prose-lg'
        : lg
        ? 'md:prose-xl'
        : xl
        ? 'prose-lg md:prose-2xl'
        : 'md:prose-lg'}

        {fluid ? 'max-w-none w-full' : ''}
    "
    {...$$restProps}
>
    <slot />
</svelte:element>